import './styles/lead-pop-game.css';
import { createLeadPop, createNoopHandle } from './lifecycle.js';
import { LeadPopGame } from './game/components/LeadPopGame.jsx';

export function LeadPopInit(element, options = {}) {
    if (!element) {
        console.warn('[lead-pop] No element provided for LeadPopInit');
        return createNoopHandle();
    }

    return createLeadPop(element, options);
}

if (typeof window !== 'undefined') {
    window.LeadPopInit = LeadPopInit;
}

export { LeadPopGame, createLeadPop, createNoopHandle };
export {
    getIntroCopy,
    getGameCopy,
    getLeadPopLocale,
    INTRO_COPY_BY_LOCALE,
} from './i18n/introCopy.js';
export {
    registerActivitySoundAsset,
    clearActivitySoundAsset,
    getActivitySoundAsset,
} from './game/audio/activitySfx.js';
export {
    registerBadItemSoundAsset,
    clearBadItemSoundAsset,
    getBadItemSoundAsset,
} from './game/audio/gameSfx.js';
export { isMuted, setMuted, toggleMuted } from './game/audio/sfxCore.js';
export { buildResultShareText, copyResultCard } from './game/share/resultShare.js';
export default LeadPopInit;
